import React from 'react';
import { MetricCard } from '../ui';
import { getValueStatus, getTrend } from '../../utils';

/**
 * Oxygen metrics section
 */
export const OxygenSection = ({ latestData, previousData, sensorConfig }) => {
  return (
    <>
      <div className="section-title">
        <span className="section-icon">💧</span>
        Oxígeno Disuelto
      </div>
      <div className="dashboard-grid fade-in stagger-2">
        <MetricCard
          icon="💧"
          label="Oxígeno Disuelto 1"
          value={latestData.do1_mgL}
          unit="mg/L"
          type="oxygen"
          trend={getTrend(latestData, previousData, 'do1_mgL')}
          valueStatus={getValueStatus(latestData.do1_mgL, sensorConfig.oxygen)}
        />
        <MetricCard
          icon="💧"
          label="Oxígeno Disuelto 2"
          value={latestData.do2_mgL}
          unit="mg/L"
          type="oxygen"
          trend={getTrend(latestData, previousData, 'do2_mgL')}
          valueStatus={getValueStatus(latestData.do2_mgL, sensorConfig.oxygen)}
        />
        <MetricCard
          icon="📊"
          label="Saturación 1"
          value={latestData.sat1_pct}
          unit="%"
          type="saturation"
          trend={getTrend(latestData, previousData, 'sat1_pct')}
          valueStatus={getValueStatus(latestData.sat1_pct, sensorConfig.saturation)}
        />
        <MetricCard
          icon="📊"
          label="Saturación 2"
          value={latestData.sat2_pct}
          unit="%"
          type="saturation"
          trend={getTrend(latestData, previousData, 'sat2_pct')}
          valueStatus={getValueStatus(latestData.sat2_pct, sensorConfig.saturation)}
        />
      </div>
    </>
  );
};
